/* eslint-disable no-undef */
import { Input } from 'antd';
import { ChangeEvent, useRef } from 'react';
import { useFetch } from '../hooks/useFetch';

interface IOrderCommentaryInputProps {
    defaultValue: string | null;
    orderId: number | null;
}

function OrderCommentaryInput({ defaultValue, orderId }: IOrderCommentaryInputProps) {
    const fetch = useFetch();
    const timeout = useRef<NodeJS.Timeout>();

    const save = async (commentary: string) => {
        await fetch.request({
            url: `/orders/${orderId}/commentary`,
            method: 'post',
            data: { commentary },
        });
    };

    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            save(e.target.value);
        }, 1000);
    };

    return (
        <Input.TextArea
            readOnly={orderId == null}
            defaultValue={defaultValue || ''}
            onChange={onChange}
        />
    );
}

export default OrderCommentaryInput;
